import { useState } from "react"
import styled from "styled-components"
import { theme } from "../../../../styles/theme"
import { Dialog } from "../../../Dialog"
import { History_Form } from "../../../Form"
import { useAuthCheck } from "../../../../hook"

export const Section_History_Header = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const { checkAuth } = useAuthCheck()
  
  return (
    <SSection className="Header" >
      {checkAuth('1000') && <button onClick={() => setIsModalOpen(true)}>엑셀 다운로드</button>}
      {!checkAuth('1000') && <h1 style={{fontSize: '20px'}}>운행 기록 페이지</h1>}
      <Dialog $isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        {isModalOpen && <History_Form onClose={() => setIsModalOpen(false)} />}
      </Dialog>
    </SSection>
  )
}

const SSection = styled.section`
  display: flex;
  justify-content: flex-start;
  & > h1 {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  & > button {
    padding: 0 10px;
    border-radius: 6px;
    border: 1px solid ${theme.colors.yellowgreen};
    &:hover {
      color: ${theme.colors.yellowgreen};
    }
  }

  & > .Popup {
    position: fixed;
    z-index: 200;
    top: 65px;
    left: 0;
    width: 100%;
    height: calc(100% - 65px);
    display: none;
    background-color: rgba(0, 0, 0, 0.5);
    justify-content: center;
    align-items: center;

    & > form {
      display: grid;
      background-color: white;

      & > select,
      & > input {
        height: 40px;
        padding: 0 10px;
      }
      & input,
      & select,
      & option {
        color: black !important;
      }
      & > footer {
        display: flex;

        & > button {
          background-color: black;
          padding: 10px;
        }
      }
    }
    &.open {
      display: flex;
    }
    &.ExcelDownload {
    }
  }

`